/** Applicant dashboard application summary layout. Set to `'list'` to compare full-width row tiles. */
export type ApplicationCardLayout = 'compact' | 'list';

export const applicationCardLayout: ApplicationCardLayout = 'list';
